<template>
    <div class="has-text-centered">
        <RoundedContainer>
            <h2>Options</h2>

            <template v-for="field in fields">
                <div class="mx-5 mt-5 mb-2">
                    <h4 class="mb-2">{{ field.visualName }}</h4>
                    <input
                        class="input is-primary slightly-rounded has-background-light"
                        type="text"
                        placeholder="Unchanged"
                        v-model="field.value"
                    />
                </div>
            </template>

        </RoundedContainer>

        <p>Please note: when you click 'confirm' 
            all selected files will be edited</p>

        <LoadingButton
            class="slightly-rounded m-1"
            text="Confirm"
            :loading="loading"
            bulma-color-class="is-primary"
            bulma-icon="fa-pencil"
            @clicked="onEditSounds">
        </LoadingButton>
    </div>
</template>

<script>
import { editSound } from '@/js/apis.js'
import LoadingButton from '@/widgets/LoadingButton.vue'
import RoundedContainer from '@/widgets/RoundedContainer.vue'

export default {
    name: 'BulkEdit',
    components: {LoadingButton, RoundedContainer},
    data(){
        return {
            loading: false,
            fields: {
                name: {
                    visualName: 'Name',
                    apiNameKey: 'name',
                    value: null,
                },
                device: {
                    visualName: 'Device',
                    apiNameKey: 'device',
                    value: null,
                },
            }
        }
    },
    props: {
        soundIds: {type: Array, default: []},
        requestingUser: {type: String, default: '', required: true},
        token: {type: String, required: true},
    },
    emits: ['bulkEditComplete'],
    computed: {
        editedFields(){
            let edited = []
            for (const field of Object.values(this.fields)) {
                // check if the field has a legitimate value
                if (field.value){
                    if (field.value.length > 0){
                        edited.push(field)
                    }
                }
            }
            return edited
        },
        dataToPut(){
            const data = {}
            // add the key value pairs to 'data'
            for (const editedField of this.editedFields){
                data[editedField.apiNameKey] = editedField.value
            }
            return data
        },
    },
    methods: {
        async onEditSounds(){
            this.loading = true
            try {
                let promises = []
                for (const soundId of this.soundIds) {
                    promises.push(editSound(
                        soundId,
                        this.requestingUser,
                        this.token,
                        this.dataToPut,
                    ))
                }
                const response = await Promise.all(promises)
                this.$emit('bulkEditComplete', response)
                this.loading = false
            }
            catch (error) {
                console.error(error)
            }
        },
    },
}
</script>

